import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import translationEN from './locales/en/translation.json';
import translationVI from './locales/vi/translation.json';
import translationJA from './locales/ja/translation.json';

// Define available languages with direction (LTR/RTL)
export const languages = {
  en: { code: 'en', label: 'English', flag: '🇺🇸', dir: 'ltr' },
  vi: { code: 'vi', label: 'Tiếng Việt', flag: '🇻🇳', dir: 'ltr' },
  ja: { code: 'ja', label: '日本語', flag: '🇯🇵', dir: 'ltr' }
};

// Resources object with translations
const resources = {
  en: { translation: translationEN },
  vi: { translation: translationVI },
  ja: { translation: translationJA }
};

// Get saved language from localStorage or use English as default
const savedLanguage = localStorage.getItem('i18nextLng');
const defaultLanguage = savedLanguage && Object.keys(languages).includes(savedLanguage) ? savedLanguage : 'en';

// Initialize i18next
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: defaultLanguage,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ['localStorage', 'navigator'], // Prioritize localStorage, then browser language
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    react: {
      useSuspense: true, // Use Suspense for async loading
      bindI18n: 'languageChanged', // Trigger re-render on language change
      bindI18nStore: 'added', // Ensure new translations trigger updates
    },
    cache: {
      enabled: false // Disable cache to ensure fresh data
    }
  });

// Handle RTL/LTR direction change
i18n.on('languageChanged', (lng) => {
  const direction = languages[lng]?.dir || 'ltr';
  document.documentElement.setAttribute('dir', direction);
  localStorage.setItem('i18nextLng', lng); // Save language choice
});

// Export i18n instance
export default i18n;